import { createApiCall } from "services/api/createApiCall";

export const getBuyerTypesAPI = async () => {
  const response = await createApiCall({
    path: "/v1/finance/lookups/invoice/buyer-types",
    method: "GET",
  })();

  return response.data;
};

export const getPaymentMethodsAPI = async () => {
  const response = await createApiCall({
    path: "/v1/finance/lookups/invoice/payment-methods",
    method: "GET",
  })();

  return response.data;
};

export const getUnitsOfMeasureAPI = async () => {
  const response = await createApiCall({
    path: "/v1/finance/lookups/invoice/units-of-measure",
    method: "GET",
  })();

  return response.data;
};

export const getLanguagesAPI = async () => {
  const response = await createApiCall({
    path: "/v1/finance/lookups/invoice/languages",
    method: "GET",
  })();

  return response.data;
};

export const getTaxTypesAPI = async () => {
  const response = await createApiCall({
    path: "/v1/finance/lookups/invoice/tax-types",
    method: "GET",
  })();

  return response.data;
};

export const getTaxExemptionReasonsAPI = async () => {
  const response = await createApiCall({
    path: "/v1/finance/lookups/invoice/tax-exemption-reasons",
    method: "GET",
  })();

  return response.data;
};
